export default __webpack_public_path__ + "static/media/curious.72321682.mp3";